import { action, observable } from 'mobx';

import { OTP_FLOW, OtpType } from '~constants/Constants';

export type OnOtpSuccessCallback = () => Promise<void>;

export class OtpStore {
    @observable
    public data: OtpStoreData;
    public onOtpSuccess?: OnOtpSuccessCallback;

    public clearStore() {
        this.setDefaultData();
    }

    @action
    public setOtpType(type: OtpType) {
        this.data = { ...this.data, type };
    }

    @action
    public setDefaultData() {
        this.data = { type: this.data.type, showOtp: false, flow: this.data.flow };
    }

    public setData(data: Partial<OtpStoreData>) {
        this.data = { ...this.data, ...data };
    }

    @action
    public setCallback = (onOtpSuccess: OnOtpSuccessCallback) => (this.onOtpSuccess = onOtpSuccess);
}

export type OtpStoreData = {
    type: OtpType;
    showOtp: boolean;
    requestId?: string;
    nonce?: string;
    resendWaitingPeriod?: number;
    lastTime?: string;
    translationKey?: string;
    hmac?: string;
    flow?: OTP_FLOW;
};
